/* Styles */
import "../style/pages/cities.css";
/* JS */
import "core-js/modules/es.array.iterator";
//@ts-ignore
import useBaseVueInstance from "@vueEntry/composables/useBaseVueInstance";
// @ts-ignore
import { BaseStore } from "@store/BaseStore";
useBaseVueInstance({
  el: "#cities-main",
  name: "cities",
  store: BaseStore,
  methods: {
    handleZoneClick(url) {
      window.location.href = url;
    }
  }
});